<template>
  <div class="checkbox" :class="{ 'has-success' : value, 'has-danger' : !value }">
      <input :style="styler" type="checkbox" class="" :id="name" :name="name" v-bind:checked="value" :ref="name" @change="onChange" :disabled="disabled">
      <label v-show="value" class="col-form-label has-success"> &nbsp {{label}}: Enabled</label>
      <label v-show="!value" class="col-form-label has-danger"> &nbsp {{label}}: Disabled</label>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    value: Boolean,
    placeholder: String,
    disabled: String,
    name: String,
    styler: {
      default:''
    },
    validation:{
      default: ''
    }
  },
  methods: {
    onChange (event) {
      this.$emit('input', event.target.checked)
    }
  }
}
</script>


// WEBPACK FOOTER //
// EnabledFormCheckbox.vue?9b51f8c8